<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
      </div>
    </div>
    <div class="imgBox1 min-w-1400" @click="toggleNewImage(1)">
      <div class="img1 max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem1" />
        <ul class="msg2">
          <li>
            <span>อีเมล</span>
            <a-input
              class="inputBox"
              v-model="formValues.email"
              placeholder="กรุณาเข้า"
            >
              <!-- <template #suffix>
                <img :src="mailIcon" />
              </template> -->
            </a-input>
          </li>
          <li>
            <span>ชื่อ</span>
            <a-input
              class="inputBox"
              v-model="formValues.mailName"
              placeholder="กรุณาเข้า"
            >
              <!-- <template #suffix>
                <img :src="mailIcon" />
              </template> -->
            </a-input>
          </li>
          <li>
            <span>อีเมล</span>
            <a-textarea
              class="textareaBox"
              v-model="formValues.remark"
              placeholder="กรุณาเข้า"
              :auto-size="{ minRows: 3, maxRows: 3 }"
            />
          </li>
          <li>
            <div>
              <a-button
                type="primary"
                :disabled="
                  formValues.mailName === '' || formValues.remark === ''
                "
                :class="{
                  submitButton: true,
                  btnBgcolor:
                    formValues.mailName !== '' && formValues.remark !== '',
                }"
                @click="submitFn"
                :loading="isLoading"
                >ส่ง</a-button
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2Box max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem2" />
      </div>
    </div>

    <div class="imgBox4 min-w-1400">
      <div class="img4Box max-w-1400">
        <!-- <img :src="importedImg4" alt="" class="imgItem4" /> -->
      </div>
    </div>
    <div class="imgBox5 min-w-1400">
      <div class="img5Box max-w-1400">
        <!-- <img :src="importedImg5" alt="" class="imgItem5" /> -->
      </div>
    </div>
    <div class="imgBox6 min-w-1400">
      <div class="img6Box max-w-1400">
        <!-- <img :src="importedImg6" alt="" class="imgItem6" /> -->
      </div>
    </div>
    <div class="imgBox7 min-w-1400">
      <div class="img7Box max-w-1400">
        <!-- <img :src="importedImg7" alt="" class="imgItem7" /> -->
      </div>
    </div>
    <div class="imgBox8 min-w-1400">
      <div class="img8Box max-w-1400">
        <!-- <img :src="importedImg7" alt="" class="imgItem8" /> -->
      </div>
    </div>
    <div class="imgBox9 min-w-1400">
      <div class="img9Box max-w-1400">
        <!-- <img :src="importedImg9" alt="" class="imgItem9" /> -->
      </div>
    </div>
    <div class="imgBox10 min-w-1400">
      <div class="img10Box max-w-1400">
        <!-- <img :src="importedImg10" alt="" class="imgItem10" /> -->
      </div>
    </div>
    <div class="imgBox11 min-w-1400">
      <div class="img11Box max-w-1400">
        <!-- <img :src="importedImg11" alt="" class="imgItem11" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import { message } from "ant-design-vue";
import importedImg1 from "@/page/growmoney/components/img/4_1.png";
import importedImg2 from "@/page/growmoney/components/img/4_2.png";
import importedImg3 from "@/page/growmoney/components/img/4_3_1.png";
// import importedImg4 from "@/page/growmoney/components/img/3_4.png";
// import importedImg5 from "@/page/growmoney/components/img/3_5.png";
// import importedImg6 from "@/page/growmoney/components/img/3_6.png";
// import importedImg7 from "@/page/growmoney/components/img/3_7.png";
// import importedImg8 from "@/page/growmoney/components/img/3_8.png";
// import importedImg9 from "@/page/growmoney/components/img/3_9.png";
// import importedImg10 from "@/page/growmoney/components/img/3_10.png";
// import importedImg11 from "@/page/growmoney/components/img/3_11.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      // importedImg4: importedImg4,
      // importedImg5: importedImg5,
      // importedImg6: importedImg6,
      // importedImg7: importedImg7,
      // importedImg8: importedImg8,
      // importedImg9: importedImg9,
      // importedImg10: importedImg10,
      // importedImg11: importedImg11,
      altText: "图片",

      formValues: {
        mailName: "",
        email: "",
        remark: "",
      },
      isLoading: false,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    submitFn() {
      if (this.formValues.mailName === "" || this.formValues.remark === "") {
        message.info("必填项不能为空");
        return;
      }
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        message.success("ส่งอีเมลเรียบร้อยแล้ว เราจะตอบกลับทันที");
        this.formValues = {
          mailName: "",
          email: "",
          remark: "",
        };
      }, 2000);
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}
img {
  display: block;
}
.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7,
.imgBox8,
.imgBox9,
.imgBox10,
.imgBox11 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box,
.img8Box,
.img9Box,
.img10Box,
.img11Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7,
.imgItem8,
.imgItem9,
.imgItem10,
.imgItem11 {
  width: 100%;
  margin: 0;
}
.img2Box {
  padding: 100px 200px;
}


.img1{
  padding: 100px 200px 0;
  display: flex;
  gap: 200px;
}
.img1 img{
  width: 40%;
}

.msg2 {
  /* border: 1px solid red; */
  display: flex;
  flex-wrap: wrap;
  /* width: 502px; */
  padding: 20px;
  gap: 10%;
  background-color: #ffffff;
}
.msg2 li {
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}
.msg2 li:nth-child(1) {
  width: 30%;
}
.msg2 li:nth-child(2) {
  width: 60%;
}
.msg2 li:nth-child(3) {
  width: 100%;
}

.msg2 li span {
  color: #333333;
  font-family: "Thonburi";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  /* opacity: 0.6; */
  padding-bottom: 10px;
}
.msg2 li input,
textarea {
  all: unset; /* 移除所有默认样式 */
  border: none; /* 去除边框 */
  outline: none; /* 去除聚焦时的轮廓 */
  background: none; /* 去除背景 */
  color: inherit; /* 继承父元素的文本颜色 */
  font: inherit; /* 继承父元素的字体 */
  border: 1px solid #397BFF;
  height: 30px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px;
}

.msg2 li a {
  width: 200px;
  height: 50px;
  line-height: 50px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #397BFF;
  color: #ffffff;
  text-align: center;
  font-family: "Thonburi";
  font-size: 20px;
  font-weight: 700;
}

.form {
  display: flex;
  flex-direction: column;
}

.inputBox {
  /* font-size: 18px;
  border: 2px solid #cdcdcd;
  border-radius: 10px;
  height: 50px; */
}

.inputBox >>> .ant-input {
  font-size: 18px;
  border: 2px solid #397BFF;
  border-radius: 10px;
  height: 56px;
  background-color: #ffffff;
}

/* .inputBox>>>.ant-input:focus {
  border: none;
  border-bottom: 1px solid white !important;
  box-shadow: 0 0 1px 2px #4263FF;
}

.inputBox>>>.ant-input:hover  {
  border: none;
  border-bottom: 1px solid white !important;
  box-shadow: 0 0 1px 2px #4263FF;
} */

.textareaBox {
  margin-top: 20px;
  border: 2px solid #397BFF;
  border-radius: 10px;
  font-size: 18px;
}
.textareaBox .ant-input {
  height: 200px;
}

.submitButton {
  /* background-color: #00BFBF !important; */
  color: #ffffff;
  border: none;
  height: 40px;
  border-radius: 5px;
  margin-top: 20px;
  width: 120px;
  font-size: 18px;
}

.btnBgcolor {
  background-color: #397BFF !important;
  color: #ffffff;
}

/* .submitButton:hover {
  background-color: #ffffff !important;
  color: #001C80;
} */

.inp {
  display: flex;
}
</style>
